import type {
  CubeLineForTab,
  FieldId,
  HttpRequestLog,
  LogLevel,
  LogMessage,
  MapInfo,
  ProjectWellVsp,
  UpdateCubeLineForTab,
} from '@core/core/types'

import type {
  CubeLineValueForTabRequest as ApiCubeLineValueForTab,
  CubeLineValueForTabResponse as ApiCubeLineValueForTabResponse,
  GridHeader as ApiGridHeader,
  HttpRequestLog as ApiHttpRequestLog,
  LogMessage as ApiLogMessage,
  MessageType as ApiMessageType,
  ProjectWellVsps as ApiWellsVsp,
  UpdateCubeLineValueForTabRequest as ApiUpdateCubeLineValueForTab,
} from './__generated__/data-contracts'

export function convertToMapInfo(from: ApiGridHeader): MapInfo {
  return {
    id: from.id,
    name: from.name,
    measureUnit: from.name,
    offsetX: from.offsetX,
    offsetY: from.offsetY,
    stepX: from.stepX,
    stepY: from.stepY,
    rotationAngle: from.rotationAngle,
    rotationX: from.rotationX,
    rotationY: from.rotationY,
  }
}

function convertLogType(from: LogLevel): ApiMessageType {
  switch (from) {
    case 'log':
      return 'Info'
    case 'warn':
      return 'Warn'
    case 'error':
      return 'Error'
  }
}

export function convertLogMessages(messages: LogMessage[]): ApiLogMessage[] {
  return messages.map(message => ({
    text: message.text,
    messageType: convertLogType(message.logLevel),
  }))
}

export function convertHttpRequestLogs(requests: HttpRequestLog[]): ApiHttpRequestLog[] {
  return requests.map(request => ({
    correlationId: request.correlationId,
    date: request.date,
    httpRequestType: request.httpRequestType,
    sizeInBytes: request.sizeInBytes,
    url: request.url,
    status: request.status,
  }))
}

export function convertToCubeLineValue(from: ApiCubeLineValueForTabResponse): number {
  return from.lineValue
}

export function convertToApiCubeLineValue(cubeLine: CubeLineForTab): ApiCubeLineValueForTab {
  return {
    lineId: cubeLine.lineId,
    projectId: cubeLine.projectId,
    tabId: cubeLine.tabId,
  }
}

export function convertToApiUpdateCubeLineValue(
  cubeLine: UpdateCubeLineForTab,
): ApiUpdateCubeLineValueForTab {
  return {
    lineId: cubeLine.lineId,
    lineValue: cubeLine.lineValue,
    projectId: cubeLine.projectId,
    tabId: cubeLine.tabId,
  }
}

export function convertWellsVsp(from: ApiWellsVsp[], fieldId: FieldId): ProjectWellVsp[] {
  return from.map(({ wellId, wellName, projectVspHeader }) => {
    return {
      wellId,
      wellName,
      fieldId,
      vspList: projectVspHeader.map(({ projectVspId, vspId, vspName, offset, isActive }) => ({
        id: projectVspId,
        vspId,
        vspName,
        offset: String(offset),
        isActive,
      })),
    }
  })
}
